// Single source of truth for the app version.
// Update this to match the last dev branch merged to main (e.g. v3.1-dev -> 'v3.1').
export const APP_VERSION = 'v4.5';
